module.exports = __webpack_public_path__ + "img/HA2506-83.5f57abb8.jpg";